import React from 'react'
import { FormattedMessage } from 'react-intl'

export const UNITS_LIST_ITEM_HEIGHT = 50
export const UNITS_LIST_VISIBLE_ITEMS = 8

export const UNITS_LIST_OTHERS_CLANS_SUBTITLE = (
    <FormattedMessage
        id='units_list.others_clans_subtitle'
        defaultMessage='Отряды других кланов'
    />
)

export const BATTLE_ROOMS_UNIT_TOOLTIP_ID = 'UNIT_TOOLTIP_ID'


// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitsList/components/TableBody/constants.js